import { Component } from 'react';
import { checkValues } from '../../EditMainInfo/validation';
import ReactSelect from '../../../components/ReactSelect';
import { updateProfile } from './queries';
import _ from 'lodash';
import Loading from '../../../components/Loading';
import { withTranslation } from 'react-i18next';
import { showMessage } from '../../../helpers/showMessage';

class AddTaxIdOrVat extends Component {
    constructor(props) {
        super();

        this.onFocus = this.onFocus.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.updateCountries = this.updateCountries.bind(this);
        this.updateTaxIdTypes = this.updateTaxIdTypes.bind(this);
        this.updateBillingCountry = this.updateBillingCountry.bind(this);
        this.tax_id_types = JSON.parse(props.tax_id_types).map((item) => ({
            value: item[0],
            label: item[1],
        }));
        this.tax_id_types.unshift({ value: '', label: 'None' });

        this.state = {
            tax_id: props.profile.tax_id ?? '',
            tax_id_type: props.profile.tax_id_type ?? '',
            company_address1: props.profile.company_address1 ?? '',
            company_address2: props.profile.company_address2 ?? '',
            billing_country: props.profile.billing_country ?? '',
            billing_city: props.profile.billing_city ?? '',
            billing_postal_code: props.profile.billing_postal_code ?? '',
            organization: props.company ?? '',
            errors: {},
            loading: false,
        };
    }

    onChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
    }

    updateTaxIdTypes(value) {
        this.setState({ tax_id_type: value });
    }

    updateBillingCountry(value) {
        const errors = { ...this.state.errors };
        delete errors['billing_country'];

        this.setState({ billing_country: value, errors });
    }

    async onSubmit(e) {
        try {
            // if we have no errors, the form from html will work
            const errors = checkValues(this.state, true);

            if (!_.isEmpty(errors)) {
                e.preventDefault();
                this.setState({ errors });
            } else {
                this.setState({
                    loading: true,
                });
                const params = {
                    tax_id: this.state.tax_id,
                    tax_id_type: this.state.tax_id_type,
                    company_address1: this.state.company_address1,
                    company_address2: this.state.company_address2,
                    billing_country: this.state.billing_country,
                    billing_city: this.state.billing_city,
                    billing_postal_code: this.state.billing_postal_code,
                    organization: this.state.organization,
                };

                const res = await updateProfile(params, this.props.csrf_token);
                const data = await res.json();
                if (res.status === 200) {
                    showMessage(data?.message ?? 'Information Updated', 'success');

                    this.props.finishSteps();
                } else {
                    showMessage(data?.message ?? 'Something went wrong', 'error');
                }
            }
        } catch (err) {
            showMessage(err.message ?? 'Something went wrong', 'error');
            console.log(err);
        } finally {
            this.setState({
                loading: false,
            });
        }
    }

    onFocus(e) {
        const key = e.target.name;
        const errors = { ...this.state.errors };
        delete errors[key];

        this.setState({ errors });
    }

    updateCountries(value) {
        this.setState({ geo_location: value });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="padding-x-20">
                    <div className="onboarding-step-10">
                        <div className="onboarding-step-10-form">
                            <div className="text-field mb-3">
                                <label htmlFor="organization" className="form-label">
                                    {t('onboarding.step_9.name')}
                                </label>
                                <input
                                    name="organization"
                                    id="organization"
                                    className="form-control"
                                    onChange={this.onChange}
                                    value={this.state.organization}
                                    onFocus={this.onFocus}
                                    placeholder={t('onboarding.step_9.name_placeholder')}
                                    tabIndex={1}
                                />
                                {this.state.errors['organization'] && (
                                    <div className="error-message">
                                        {this.state.errors['organization']}
                                    </div>
                                )}
                            </div>
                            {/* COMPANY NAME + BILLING COUNTRY */}
                            <div className="text-field mb-3">
                                <div>
                                    <label htmlFor="company_address1" className="form-label">
                                        {t('onboarding.step_9.address_1')}
                                    </label>
                                    <input
                                        name="company_address1"
                                        id="company_address1"
                                        className="form-control"
                                        onChange={this.onChange}
                                        value={this.state.company_address1}
                                        onFocus={this.onFocus}
                                        placeholder={t('onboarding.step_9.address_placeholder')}
                                        tabIndex={3}
                                    />
                                    {this.state.errors['company_address1'] && (
                                        <div className="error-message">
                                            {this.state.errors['company_address1']}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* VAT / TAX ID */}
                            <div className="text-field mb-3">
                                <label htmlFor="vat-tax-id" className="form-label">
                                    {t('onboarding.step_9.vat_tax_id')}
                                </label>
                                <input
                                    name="tax_id"
                                    type="text"
                                    id="vat-tax-id"
                                    className="form-control"
                                    onChange={this.onChange}
                                    value={this.state.tax_id}
                                    onFocus={this.onFocus}
                                    placeholder={t('onboarding.step_9.vat_tax_id_placeholder')}
                                    tabIndex={2}
                                />
                                {this.state.errors['tax_id'] && (
                                    <div className="error-message">
                                        {this.state.errors['tax_id']}
                                    </div>
                                )}
                            </div>
                            <div className="text-field mb-3">
                                <label htmlFor="company_address2" className="form-label">
                                    {t('onboarding.step_9.address_2')}
                                </label>
                                <input
                                    name="company_address2"
                                    id="company_address2"
                                    className="form-control"
                                    onChange={this.onChange}
                                    value={this.state.company_address2}
                                    onFocus={this.onFocus}
                                    placeholder={t('onboarding.step_9.address_placeholder')}
                                    tabIndex={4}
                                />
                            </div>

                            {/* TAX ID TYPE */}
                            <div className="text-field mb-3">
                                <label htmlFor="tax_id_type" className="form-label">
                                    {t('onboarding.step_9.tax_id_type')}
                                </label>
                                <input
                                    type="hidden"
                                    name="tax_id_type"
                                    value={this.state.tax_id_type}
                                />
                                <ReactSelect
                                    options={this.tax_id_types}
                                    onChange={this.updateTaxIdTypes}
                                    isSearchable={true}
                                    value={this.tax_id_types.find(
                                        (item) => item.value === this.state.tax_id_type,
                                    )}
                                    blurInputOnSelect={true}
                                    classname="m-0"
                                    controlStyles={{ height: '35px' }}
                                    placeholder={t('onboarding.step_9.choose_type')}
                                    onFocus={() =>
                                        this.onFocus({ target: { name: 'tax_id_type' } })
                                    }
                                />
                                {this.state.errors['tax_id_type'] && (
                                    <div className="error-message">
                                        {this.state.errors['tax_id_type']}
                                    </div>
                                )}
                            </div>

                            {/* COMPANY NAME + BILLING COUNTRY */}
                            <div className="text-field mb-3">
                                <div>
                                    <label htmlFor="billing_country" className="form-label">
                                        {t('onboarding.step_9.billing_country')}
                                    </label>
                                    <input
                                        type="hidden"
                                        name="billing_country"
                                        value={this.state.billing_country}
                                    />
                                    <ReactSelect
                                        options={this.props.geolocation}
                                        value={this.props.geolocation.find(
                                            (x) => x.value === this.state.billing_country,
                                        )}
                                        controlStyles={{ height: '35px' }}
                                        isSearchable={true}
                                        placeholder="Billing Country"
                                        onChange={this.updateBillingCountry}
                                        blurInputOnSelect={true}
                                        classname="mr-0"
                                    />
                                    {this.state.errors['billing_country'] && (
                                        <div className="error-message">
                                            {this.state.errors['billing_country']}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div></div>

                            {/* CITY + POSTAL CODE */}
                            <div className="text-field mb-3 onboarding-step-10-form">
                                <div>
                                    <label htmlFor="billing_city" className="form-label">
                                        {t('onboarding.step_9.billing_city')}
                                    </label>
                                    <input
                                        name="billing_city"
                                        id="billing_city"
                                        className="form-control"
                                        onChange={this.onChange}
                                        value={this.state.billing_city}
                                        onFocus={this.onFocus}
                                        placeholder={t('onboarding.step_9.city_placeholder')}
                                        tabIndex={5}
                                    />
                                    {this.state.errors['billing_city'] && (
                                        <div className="error-message">
                                            {this.state.errors['billing_city']}
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <label htmlFor="billing_postal_code" className="form-label">
                                        {t('onboarding.step_9.billing_postal_code')}
                                    </label>
                                    <input
                                        name="billing_postal_code"
                                        id="billing_postal_code"
                                        className="form-control"
                                        onChange={this.onChange}
                                        value={this.state.billing_postal_code}
                                        onFocus={this.onFocus}
                                        placeholder={t('onboarding.step_9.postal_code_placeholder')}
                                        tabIndex={6}
                                    />
                                    {this.state.errors['billing_postal_code'] && (
                                        <div className="error-message">
                                            {this.state.errors['billing_postal_code']}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {this.state.message && (
                            <div className={`onboarding-message-${this.message_tags}`}>
                                {this.message}
                            </div>
                        )}
                    </div>
                </div>

                <div className="onboarding-container-item-body-footer ">
                    <button className="onboarding-skip-btn" onClick={() => this.props.handleBack()}>
                        {t('onboarding.back')}
                    </button>
                    <button
                        className="onboarding-btn-next"
                        onClick={this.onSubmit}
                        disabled={this.state.loading}
                    >
                        {this.state.loading && <Loading onlyPreloader />}
                        {t('onboarding.save')}
                    </button>
                </div>
            </>
        );
    }
}

export default withTranslation()(AddTaxIdOrVat);
